import { openBlock, createElementBlock, normalizeClass, renderSlot } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper.mjs";
const _sfc_main = {
  name: "NcAppContentList",
  props: {
    /**
     * Is the list selected
     */
    selection: {
      type: Boolean,
      default: false
    },
    /**
     * Is the details pane shown
     */
    showDetails: {
      type: Boolean,
      default: false
    }
  }
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["app-content-list", { selection: $props.selection, showdetails: $props.showDetails }])
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 2);
}
const NcAppContentList = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  NcAppContentList as N
};
//# sourceMappingURL=NcAppContentList.mjs.map
